import styled from "styled-components";
import {
  headerSize,
  panelSpacing,
  Scrollable,
} from "../../../../../../common/styles";
import colors from "../../../../../../config/colors";

export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: ${panelSpacing}px;
`;

// export const AvatarName = styled.p`
//   // min-width: fit-content;
//   max-width: 100%;
//   overflow: hidden;
// `;
export const AvatarName = styled.p`
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block; /* required if not already block/flex */
`;

export const DateTag = styled.p`
  min-width: max-content;
`;

export const NameContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const AvatarInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  p {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
  }
`;

export const DropIcon = styled.div`
  cursor: pointer;
`;
export const DropdownItems = styled.div`
  position: absolute;
  top: 25px;
  left: -50px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  z-index: 2;
`;

export const DropdownButton = styled.button`
  width: 100%;
  padding: 10px;
  border: none;
  border-bottom: 1px solid #ddd;
  background-color: white;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  svg {
    margin-right: 8px;
  }
`;

export const MentorsContainerOuter = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  padding: 16px 24px;
  margin: 12px;
  ${Scrollable}
  height: calc(100vh - 190px);
`;

export const MentorsHead = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media (max-width: 767px) {
    margin-bottom: 30px;
  }
`;

export const ButtonText = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;

export const BackButton = styled.button`
  border-radius: 5px;
  border: 1px solid #302f2f;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: transparent;
  width: 100px;
  height: 40px;
`;

export const FilterOptions = styled.div`
  position: absolute;
  right: 0px;
  top: 43px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 4px 50px 0px rgba(151, 140, 140, 0.2);
  padding: 10px 12px;
  z-index: 3;
  width: 250px;
`;
export const FilterHeadText = styled.h3`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0 0 10px;
`;
export const FilterBy = styled.div`
  border-top: 1px solid #e2ebf3;
  border-bottom: 1px solid #e2ebf3;
  padding-bottom: 16px;
`;
export const FilterLabel = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 16px 0 8px;
`;
export const FilterLabelText = styled.h3`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;
export const FilterClear = styled.div`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
`;

export const FilterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`;
export const ResetButton = styled.div`
  border-radius: 5px;
  border: 1px solid #ededed;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 5px 8px;
  cursor: pointer;
`;
export const ApplyButton = styled.div`
  border-radius: 5px;
  border: 1px solid #ededed;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 5px 8px;
  background: #45459b;
  color: #ffffff;
  cursor: pointer !important;
`;

export const MentorsBottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 10px;
  align-items: center;
  @media (max-width: 767px) {
    flex-direction: column;
    gap: 20px;
    margin-top: 30px;
  }
`;

export const FilterOption = styled.div`
  border-radius: 3px;
  background: #44449b;
  display: flex;
  gap: 12px;
  width: 100px;
  height: 32px;
  justify-content: center;
  align-items: center;
  padding: 5px 8px;
  cursor: pointer;
`;

export const FilterText = styled.h3`
  color: #fff;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const SearchBoxFilterContainer = styled.div`
  display: flex;
  gap: 11px;
  position: relative;
`;

export const DateInputs = styled.div`
  display: flex;
`;

export const SearchParticipantsWrapper = styled.div`
  position: relative;
  input {
    padding: 9px 10px 9px 35px;
  }
  svg {
    position: absolute;
    top: 8px;
    left: 5px;
    z-index: 5;
  }
`;

export const MentorsHeading = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const ProfileImageContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
`;

export const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
`;

export const ProfileHidden = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #fff;
  background: #dadade;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.7px;
`;

export const List = styled.div`
  display: flex;
  width: 715px;
  max-height: 400px;
  position: absolute;
  padding: 16px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 4px 50px 0px rgba(151, 140, 140, 0.2);
  top: 30px;
  left: -300px;
  z-index: 10;
`;

export const Participant = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => props.isMembers && "#FFFFFF"};
  padding: ${(props) => props.isMembers && "8px 12px"};
  border-radius: ${(props) => props.isMembers && "5px"};
`;
export const ListInner = styled.div`
  width: 100%;
`;
export const ParticipantInfo = styled.div`
  display: flex;
  gap: 8px;
`;
export const ParticipantImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`;
export const ParticipantInfoDescription = styled.div`
  text-align: left;
`;

export const ParticipantName = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;
export const ParticipantRole = styled.p`
  color: #757575;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin: 0;
  text-transform: capitalize;
`;
export const ParticipantDetails = styled.div`
  color: #4a499a;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
export const ParticipantActions = styled.div``;

export const ParticipantMembers = styled.div`
  border-radius: 5px;
  background: #f2f2f2;
  padding: 12px;
  margin-top: 12px;
  max-height: 400px;
  overflow: auto;
`;

export const Select = styled.select`
  width: 141px;
  height: 36px;
  color: #b3b3b3;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 5px;
  border: 1px solid #dbdbdb;
  background: #fff;
  padding: 8px;
  &:focus {
    outline: none;
  }
`;

export const Option = styled.option`
  color: #b3b3b3;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TableContainer = styled.div``;

export const MentorDescription = styled.div``;

export const MentorsInfo = styled.p`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 8px 0 0;
`;

export const LoaderContainer = styled.div`
  background-color: ${colors.background};
  border-radius: ${panelSpacing}px;
  box-sizing: border-box;
  height: calc(100vh - ${headerSize + 2 * panelSpacing}px);
`;

export const ExportDeleteBtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const FilterContainer = styled.div``;

export const ExportContainer = styled.div`
  position: relative;
`;

export const Export = styled.button`
  height: 44px;
  padding: 5px 8px;
  display: flex;
  gap: 10px;
  border-radius: 5px;
  border: 1px solid #ededed;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: transparent;
`;

export const ExportText = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;

export const ExportOptions = styled.div`
  position: absolute;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  width: 240px;
  right: 0;
  z-index: 11;
`;

export const ExportOption = styled.button`
  background: transparent;
  border: none;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  padding: 12px;
  border-bottom: 1px solid #ddd;
  width: 100%;
  text-align: left;
`;

export const NotFoundMessage = styled.span`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 700;
  @media (max-width: 767px) {
    font-size: 15px;
  }
`;
